jQuery( document ).ready( function(){
    jQuery('.loader').fadeOut('slow', function() {
        jQuery(this).remove();
    });
})

